import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import PersonIcon from "@mui/icons-material/Person";
import TopicIcon from "@mui/icons-material/Topic";

import Layout from "../components/layout/Layout";
import { useUserFetch } from "../api/fetch";


export default function User() {
  const [lectureData, setLectureData] = useState<any[]>([]);
  const [userName, setUserName] = useState("");
  const { get } = useUserFetch();
  
  useEffect(() => {
    get<{
      message: string;
      lectures: any[];
      userName: string;
    }>(`/api/user/lectures`).then((res) => {
      console.log(res.message);
      setLectureData(res.lectures);
      setUserName(res.userName);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout userName={userName}>
      <List>
        <ListItem key={"MyPage"} disablePadding>
          <ListItemButton component={Link} to="/">
            <PersonIcon />
            <ListItemText primary={"マイページ"} />
          </ListItemButton>
        </ListItem>
        <Divider />
        {lectureData && (
          lectureData.map((row: any) => (
            <ListItem key={row.id} disablePadding>
              <ListItemButton component={Link} to={"/lecture/" + row.id}>
                <TopicIcon />
                <ListItemText primary={row.lectureName} />
              </ListItemButton>
            </ListItem>
          ))
        )}
      </List>
    </Layout>
  );
}
